import { Injectable } from '@angular/core';
import { HttpService, PaymentgetwayService } from '../..';

@Injectable({
  providedIn: 'root'
})
export class DebitCardPaymentService {

  constructor(private http: HttpService, private PAYMENT_TYPE: PaymentgetwayService) { }

  makePayment(DEBITCARD_INFO: any, TANX_ID: any) {
    const DEBITCARD_DATA = DEBITCARD_INFO;
    const PAYMENT_TYPE = this.PAYMENT_TYPE?.DebitCard;
    const body = new URLSearchParams();
    body.set("id", TANX_ID);
    body.set("cc[store]", PAYMENT_TYPE?.debit_store_value)
    body.set("cc[number]", DEBITCARD_DATA?.debit_card_number)
    body.set("cc[exp_month]", DEBITCARD_DATA?.debit_card_exp_month)
    body.set("cc[exp_year]", DEBITCARD_DATA?.debit_card_exp_year)
    body.set("cc[cvv]", DEBITCARD_DATA?.debit_card_cvv)
    body.set("cc[name]", DEBITCARD_DATA?.debit_card_holder_name)
    body.set("cc[card]", PAYMENT_TYPE?.debit_value_card)
    body.set("cc[payOption]", PAYMENT_TYPE.debit_value_payOption)
    body.set("payment[payment_type]", PAYMENT_TYPE?.debit_payment_type)
    body.set("payment[value][store]", PAYMENT_TYPE?.debit_store_value)
    body.set("payment[value][number]", DEBITCARD_DATA?.debit_card_number)
    body.set("payment[value][exp_month]", DEBITCARD_DATA?.debit_card_exp_month)
    body.set("payment[value][exp_year]", DEBITCARD_DATA?.debit_card_exp_year)
    body.set("payment[value][cvv]", DEBITCARD_DATA?.debit_card_cvv)
    body.set("payment[value][name]", DEBITCARD_DATA?.debit_card_holder_name)
    body.set("payment[value][card]", PAYMENT_TYPE?.debit_value_card)
    body.set("payment[value][payOption]", PAYMENT_TYPE.debit_value_payOption)
    body.set("is_api_payment", 'true')
    return this.http.flightsave('b2c/booking/payment', body);
  }
}
